import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'opportunityStage',
  standalone: false
})
export class OpportunityStagePipe implements PipeTransform {
  
  // Mapa de etapas a estilos
  private stageStyles: { [key: string]: { label: string; backgroundColor: string; color: string } } = {
    'Cotización': {
      label: 'Cotización',
      backgroundColor: '#FFF4D6',
      color: '#A35200'
    },
    'Nuevo': {
      label: 'Nuevo',
      backgroundColor: '#EBF5FF',
      color: '#0068D6'
    },
    'Inicio': {
      label: 'Inicio',
      backgroundColor: '#E8F4F8',
      color: '#0066CC'
    },
    'Evaluación': {
      label: 'Evaluación',
      backgroundColor: '#F9F1FE',
      color: '#7820BC'
    },
    'Pausada': {
      label: 'Pausada',
      backgroundColor: '#FEECF2',
      color: '#BD2864'
    },
    'Adjudicada': {
      label: 'Adjudicada',
      backgroundColor: '#EBFAEB',
      color: '#297A3A'
    },
    'Completada': {
      label: 'Completada',
      backgroundColor: '#D4EDDA',
      color: '#155724'
    },
    'Cancelada': {
      label: 'Cancelada',
      backgroundColor: '#FFEBEB',
      color: '#CB2A2F'
    }
  };

  transform(value: string): { label: string; backgroundColor: string; color: string } {
    const defaultStyle = {
      label: value || 'Desconocido',
      backgroundColor: '#EBEBEB',
      color: '#171717'
    };

    if (!value) return defaultStyle;

    const stage = this.stageStyles[value];
    return stage || defaultStyle;
  }
}

